"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var crypto_1 = require("crypto");
function hashData(algorithm, data, encoding) {
    if (encoding === void 0) { encoding = 'hex'; }
    return crypto_1.createHash(algorithm).update(data).digest(encoding);
}
exports.default = hashData;
